

/// <reference path="CoreEntityUpdatedBy.ts" />

// Generated class Report_ManagedObject

class Report_ManagedObject extends CoreEntityUpdatedBy
{

    // Property: key
    set key(value:string) {
        this.setValueForKey(value, 'key');
    }
    get key():string {
        return this.valueForKey('key');
    }
    set keyPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'key');
    }
    get keyPrimitiveValue():string {
        return this.primitiveValueForKey('key');
    }

    // Property: orderIndex
    set orderIndex(value:number) {
        this.setValueForKey(value, 'orderIndex');
    }
    get orderIndex():number {
        return this.valueForKey('orderIndex');
    }
    set orderIndexPrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'orderIndex');
    }
    get orderIndexPrimitiveValue():number {
        return this.primitiveValueForKey('orderIndex');
    }

    // Property: path
    set path(value:string) {
        this.setValueForKey(value, 'path');
    }
    get path():string {
        return this.valueForKey('path');
    }
    set pathPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'path');
    }
    get pathPrimitiveValue():string {
        return this.primitiveValueForKey('path');
    }

    // Property: scriptType
    set scriptType(value:string) {
        this.setValueForKey(value, 'scriptType');
    }
    get scriptType():string {
        return this.valueForKey('scriptType');
    }
    set scriptTypePrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'scriptType');
    }
    get scriptTypePrimitiveValue():string {
        return this.primitiveValueForKey('scriptType');
    }

    // Property: visible
    set visible(value:boolean) {
        this.setValueForKey(value, 'visible');
    }
    get visible():boolean {
        return this.valueForKey('visible');
    }
    set visiblePrimitiveValue(value:boolean) {
        this.setPrimitiveValueForKey(value, 'visible');
    }
    get visiblePrimitiveValue():boolean {
        return this.primitiveValueForKey('visible');
    }

    // Relationship: localizedEntities
    protected _localizedEntities:MIOManagedObjectSet = null;
    get localizedEntities():MIOManagedObjectSet {
        return this.valueForKey('localizedEntities');
    }
    addLocalizedEntitiesObject(value:ReportLocalized) {
        this._addObjectForKey(value, 'localizedEntities');
    }
    removeLocalizedEntitiesObject(value:ReportLocalized) {
        this._removeObjectForKey(value, 'localizedEntities');
    }
}
